import React from 'react'
import { Link } from 'react-router-dom'
import * as Scroller from 'react-scroll'


function About() {

    React.useEffect(() => {
        Scroller.animateScroll.scrollToTop()
    }, [])

    const [display, setDisplay] = React.useState(true)

    return (
        <div className="cv_page">
            <div className="cv_item_big">
                <div className="cv_title"></div>
                <div className="cv_big animated fadeInIn">
                    Constantly in motion, learning, trying and doing great things.
                </div>
            </div>
            <div className="cv_item animated delay04 fadeInIn">
                <div className="cv_title">
                    About
                </div>
                <div className="cv_content">
                    {display ?
                        `I’m David Ayoola, a multidisciplinary developer with 6+ years of experience. I develop to solve human problems by identifying them, examining alternate solutions to them then choosing and executing the best solution. I'm passionate about technology, music, coffee and everything visually stimulating. Constantly learning and experiencing new things. Just a peek at who I am.` :
                        <div className="cv_content  animated delay06 fadeInIn">
                            <p className="size-large">
                                Hi again, David Here. I'm a multi-talented tecch enthusiast with over 6+ years of experiences in a wide range of design and development disciplines.
                            </p>
                            <p>
                                You can also call me a Software/UI/Frontend/Web/Backend/Fullstack Developer, UI designer, Software Engineer, or by any other market defined function-title. I'm also a multi-disciplinary worker with over 10 years of experiences in development, management, advisory, entrepreneurship, design, music and more.
                            </p>
                            <p>
                                I don’t like to define myself by the work I’ve done. I define myself by the work I want to do. Skills can be taught, personality is inherent. I prefer to keep learning, continue challenging myself, and do interesting things that matter.
                            </p>
                            <p>
                                Fueled by high energy levels and boundless enthusiasm, I’m easily inspired and more than willing to follow my fascinations wherever they take me. I’m a passionate, expressive, innovative and multi-talented person with a natural ability to entertain and inspire. I’m never satisfied to just come up with ideas. Instead I have an almost impulsive need to act on them.
                            </p>
                            <p>
                                My abundant energy fuels me in the pursuit of many interests, hobbies, areas of study and artistic endeavors. I’m a fast learner, able to pick up new skills and juggle different projects and roles with relative ease.
                            </p>
                            <p>
                                I am an ideator, who always sees solutions in every situation and never dwells on the problem itself. I am never afraid to <strong>start</strong>, I always act upon my ideas with enthusiasm, to see where the journey leads me.
                            </p>
                            <p>
                                I like to develop expertise in a number of areas over the course of my life and career. My personality type is <a className="underline text-color-white" href="http://www.personalitypage.com/ENTJ.html" target="_blank" rel="noreferrer"> ENTJ</a>. I currently work remotely with a selected client base and am open for new opportunities.
                            </p>
                            <p>
                                You can read more about professional career on the page or in the pdf below:
                            </p>
                        </div>
                    }
                    <div className="links animated fadeInIn" data-aos="fade-up" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", height: "50px" }} >
                        <div onClick={() => setDisplay(!display)} className="cv_btn" claclassNamess="on-hover-40 text-color-red footer_back animated delay06 fadeInIn" href="" target="_blank" rel="noreferrer">{display ? "Read More" : "Return"} </div>
                        <a style={{ padding: 0 }} className="on-hover-40 text-color-red footer_back animated delay06 fadeInIn" href="https://drive.google.com/file/d/1yg7vofFs0R5zVpxyX0x5MIYoGtAiLJOn/view?usp=sharing" target="_blank" rel="noreferrer">My resume (pdf) </a>
                    </div>
                </div>
            </div>
            <div style={display ? { display: 'block' } : { display: 'none' }} className="cv_item animated delay06 fadeInIn">
                <div className="cv_title">
                    Skills
                </div>
                <div className="cv_content bullet">
                    <ul>
                        <li>Superior skill with Javascript.</li>
                        <li>Strong foundation in web design CSS, HTML.</li>
                        <li>Excellent understanding of CSS framworks like Sass, TailwindCSS and Boostrap.</li>
                        <li>Strong mastery of Javascript Front-end frameworks like React, React-Native (Mobile Apps), Electron (Desktop Apps) and VueJs.</li>
                        <li>Good knowledge of Javascript Back-end technology using NodeJs, Express, MongoDB and PostgreSQL.</li>
                        <li>familiar with GSAP, jQuery, PHP, Python, Swift, Dart (Flutter), MySQL and C#.</li>
                        <li>UI design experience with AdobeXD and Figma.</li>
                        <li>Vector graphics with Illustrator, prototyping with JustInmind etc.</li>
                        <li>Familiar with motion graphics and animations in After Effects.</li>
                        <li>Familiar with 3D animations, geometric modeling, SVG manipulatons and web animations.</li>
                        <li>Familiar with the music production process.</li>
                    </ul>
                </div>
            </div>
            <div style={display ? { display: 'block' } : { display: 'none' }} className="cv_item animated delay08 fadeInIn">
                <div className="cv_title">
                    I have
                </div>
                <div className="cv_content bullet">
                    <ul>
                        <li>A passion for experience design, with focus on building functional and usable products.</li>
                        <li>High self-motivation in working individually and closely with other teams.</li>
                        <li>Great storytelling, communication and collaboration skills.</li>
                        <li><strong>A keen eye for </strong>creating heuristic analysis and quantitative surveys,</li>
                        <li>Solving key development problems through ideation and a strict issue resolution workflow,</li>
                        <li>Sketching, creating wireframes, prototyping, storytelling,</li>
                        <li>UI Design to frontend interpretation, state management and creating pixel perfect frontend results.</li>
                        <li><strong>The ability to</strong> build user stories, use cases and scenarios and implement them,</li>
                        <li>Design functional APIs, Develop backend systems and business logic for product support.</li>
                        <li>Knowledge of data structures, application logic and architecture,</li>
                        <li>Writing technical and non-technical documentation.</li>
                        <li>Good Unit, end-to-end testing as well as some familiarity with the TDD workflow.</li>
                        <li>A relentless attention to detail.</li>
                        <li>Experience in entrepreneurship and building a start-up.</li>
                        <li>Experience in responsive web design, cross-platform compatible coding techniques and troubleshooting.</li>
                        <li>Very positive attitude with an empathetic and holistic view.</li>
                    </ul>
                </div>
            </div>
            <div style={display ? { display: 'block' } : { display: 'none' }} className="cv_item animated delay10 fadeInIn">
                <div className="cv_title">
                    I love
                </div>
                <div className="cv_content bullet">
                    <ul>
                        <li>Great relationships, big ideas and collaboration opportunities.</li>
                        <li>A good cup of coffee.</li>
                        <li>Curating music playlists and making song covers.</li>
                        <li>Traveling, exploring new places and taking photos.</li>
                        <li>reading blogs, books and being engaged.</li>
                        <li>Learning new things and always being in motion.</li>
                        <li>Experimenting with designs and new/exciting technologies.</li>
                    </ul>
                </div>
            </div>
            <div style={display ? { display: 'block' } : { display: 'none' }} className="cv_item animated delay12 fadeInIn">
                <div className="cv_title">
                    Experiences
                </div>
                <div className="cv_content">
                    <ul>
                        <li className="bold">Tech Lead (full-stack)</li>
                        <li>Vigho - <em>part remote</em></li>
                        <li className="light">December 2021 - current</li>
                        <li style={{ listStyle: "none" }}><br /></li>
                        <li className="bold">Snr. Software Developer (React, React Native &amp; Swift)</li>
                        <li>Oudi Inc (Gist App) - <em>remote</em></li>
                        <li className="light">March 2021 - current</li>
                        <li style={{ listStyle: "none" }}><br /></li>
                        <li className="bold">Front-End Developer</li>
                        <li>3Line - <em>part remote</em></li>
                        <li className="light">September 2020 - current</li>
                        <li style={{ listStyle: "none" }}><br /></li>
                        <li className="bold">Front-End Developer</li>
                        <li>Friyay - <em>contract</em></li>
                        <li className="light">March 2020 - June 2020</li>
                        <li style={{ listStyle: "none" }}><br /></li>
                        <li className="bold">Lead Web Developer</li>
                        <li>Kallwealth - <em>contract</em></li>
                        <li className="light">October 2019 - March 2020</li>
                        <li style={{ listStyle: "none" }}><br /></li>
                        <li className="bold">Software Developer</li>
                        <li>EHealth4everyone</li>
                        <li className="light">February 2019 - September 2020</li>
                        <li style={{ listStyle: "none" }}><br /></li>
                        <li className="bold">IT Associate</li>
                        <li>NITDA</li>
                        <li className="light">January 2017 - October 2017</li>
                        <li style={{ listStyle: "none" }}><br /></li>
                        <li className="bold">Lead Software Engineer (full-stack)</li>
                        <li>HiddenHyve - <em>freelance</em></li>
                        <li className="light">September 2016 - December 2018</li>
                        <li style={{ listStyle: "none" }}><br /></li>
                        <li className="bold">Exec. Director &amp; Co-Founder</li>
                        <li>Deanav Ventures</li>
                        <li className="light">2016 - 2018, 2020 - ♾️</li>
                    </ul>
                </div>
            </div>
            <div style={display ? { display: 'block' } : { display: 'none' }} className="cv_item animated delay14 fadeInIn">
                <div className="cv_title">
                    Education
                </div>
                <div className="cv_content">
                    <ul>
                        <li className="bold">Bachelor of Science - Computer Science</li>
                        <li>Landmark University</li>
                        <li className="light">20014 – 2018</li>
                        <li style={{ listStyle: "none" }}><br /></li>
                        {/* <li className="bold">High School</li>
                        <li>Digital Communication and Media/Multimedia School For Design</li>
                        <li className="light">2004 – 2008</li> */}
                    </ul>
                </div>
            </div>
            {/* <div style={display ?{display:'block'}:{display:'none'}} className="cv_item animated delay06 fadeInIn">
                <div className="cv_title">
                    Volunteer Experience
                </div>
                <div className="cv_content">
                    <ul>
                        <li className="bold">Co-founder of Eduplay</li>
                        <li>Microsoft Imagine Cup - Eduplay</li>
                        <li className="light">Participating at Imagine cup to solve the world's toughest challenges. The main goal was to building a computer software that enables children to learn independently and play educational games. The program has been designed and adapted for children with special needs.</li>
                    </ul>
                </div>
            </div>
            <div style={display ?{display:'block'}:{display:'none'}} className="cv_item animated delay06 fadeInIn">
                <div className="cv_title">
                    Honors and awards
                </div>
                <div className="cv_content">
                    <ul>
                        <li className="bold">Awesome Designer #106</li>
                        <li>365 Awesome Designers</li>
                        <li className="light">April 2015</li>
                        <li style={{ listStyle: "none" }}><br /></li>
                        <li className="bold">Outstanding Contribution At FERI University</li>
                        <li>Faculty of Electrical Engineering and Computer Science</li>
                        <li className="light">September 2012</li>
                        <li style={{ listStyle: "none" }}><br /></li>
                        <li className="bold">Microsoft Imagine Cup</li>
                        <li>Second award at the National Competition Imagine Cup</li>
                        <li className="light">May 2010</li>
                    </ul>
                </div>
            </div> */}
            <div className="footer_back animated delay06 fadeInIn">
                <Link to={"/"} className="cv_btn" >
                    Go BACK
                </Link>
            </div>
        </div>
    )
}

export default About